const TEXTE_RELANCE_AVANT_ECHEANCE_DEFAUT = `Madame, Monsieur,

Sauf erreur de notre part, nous constatons qu'à la date du {Date_du_jour}, vous nous êtes toujours redevable de la somme de {Montant_total} correspondant à :

{Tableau_factures}

Nous vous rappelons que cette somme doit être réglée au plus tard le {Date_limite_paiement}.

Le paiement peut être effectué :

• en ligne via le portail de paiement sécurisé :
• par chèque à l'ordre du Trésor Public.
• ....

À défaut de règlement dans le délai imparti, votre dossier pourra être transmis au comptable public pour recouvrement, ce qui entraînera des frais supplémentaires et/ou l'engagement d'une procédure contentieuse.

Nous vous invitons à nous contacter rapidement si vous avez déjà effectué le paiement ou si vous rencontrez des difficultés financières, afin d'étudier ensemble une solution adaptée.

Si toutefois le règlement avait été effectué entre-temps, nous vous prions de ne pas tenir compte de ce courrier.

Comptant sur votre diligence, nous vous prions d'agréer, Madame, Monsieur, l'expression de nos salutations distinguées.`;

export default TEXTE_RELANCE_AVANT_ECHEANCE_DEFAUT;
